import { axios } from "../config/axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import {
  FeedbackSource,
  FeedbackStatus,
  ICustomerFeedback,
  IFeedbackStats,
  IUpdateFeedbackStatus
} from "../interfaces/endpoints/ICustomerFeedback";
import { serialize } from "../utils/serializeToQueryString";

export type GetAllFeedbackParamsType = {
  source?: FeedbackSource;
  status?: FeedbackStatus;
  route?: string;
  dateFrom?: string;
  dateTo?: string;
  hasEmail?: boolean;
  hasMessage?: boolean;
  hasReasons?: boolean;
  pageIndex?: number;
  pageSize?: number;
  searchkeyword?: string;
};

export const getAllFeedback = async (
  params: GetAllFeedbackParamsType
): Promise<IAxiosResponse<ICustomerFeedback[]>> => {
  return axios.get<ICustomerFeedback[]>(
    `/v1/UserFeedback/Get${serialize(params)}`
  );
};

export const getFeedbackById = async (
  id: number
): Promise<IAxiosResponse<ICustomerFeedback>> => {
  return axios.get(`/v1/UserFeedback/Detail/${id}`);
};

export const updateFeedbackStatus = async (
  id: number,
  body: IUpdateFeedbackStatus
): Promise<IAxiosResponse<unknown>> => {
  return axios.put(`/v1/UserFeedback/Status/${id}`, body);
};

export const getFeedbackStats = async (): Promise<
  IAxiosResponse<IFeedbackStats>
> => {
  return axios.get("/v1/UserFeedback/Stats");
};
